import React from 'react';
import {useDownloadURL} from "react-firebase-hooks/storage";
import {firebaseStorage, storageRef} from "../../../firebase/client-app";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";

const ShowProductImageSmall = ({imageDetail, productImageUrl = null}) => {
    const [value, loading, error] = useDownloadURL(storageRef(firebaseStorage, imageDetail?.imageFilePath));
    
    let modes = {
        'fill': 'cover',
        'fit': 'contain'
    };
    let size = modes['fit'] || 'contain';

    let defaults = {
        height: 50,
        width: 50,
        backgroundColor: 'bg-white',
    };

    return (
        <>
            {!loading && value &&
                <div style={{
                    ...defaults, backgroundSize: size,
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: `url("${value}")`
                }}
                     className={`'border-gray-200 bg-white'} text-center hover:bg-neutral-400 border rounded m-1 cursor-pointer`}/>

            }

            {loading && !value &&
                <div
                    className="border-gray-200 bg-white text-center hover:bg-neutral-400 border rounded m-1 cursor-pointer">
                    <div style={{
                        ...defaults, backgroundSize: size,
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                    }}/>
                </div>
            }

            {!loading && !value &&
                <ProductImageSmall
                    imageUrl={productImageUrl}/>
            }
        </>
    )
}

export default ShowProductImageSmall
